module.exports = __webpack_public_path__ + "img/hostel-view.ab052af4.jpg";